import IBullData from "../models/IBullData";

export enum ActionType {
  FetchBullOptions = "FETCH_BULL_OPTIONS",
  ReceiveBullOptions = "RECEIVE_BULL_OPTIONS",
  ReceiveBullOptionsError = "RECEIVE_BULL_OPTIONS_ERROR",
}

export interface IFetchBullOptionsAction {
  type: ActionType.FetchBullOptions;
}

export interface IReceiveBullOptionsAction {
  type: ActionType.ReceiveBullOptions;
  payload: IBullData[];
}

export interface IReceiveBullOptionsErrorAction {
  type: ActionType.ReceiveBullOptionsError;
}

export function fetchBullOptions(): (
  dispatch: (actions: Action) => void,
  getState: () => any
) => void {
  // make an API request to S3
  return async (dispatch) => {
    dispatch({
      type: ActionType.FetchBullOptions,
    });

    // eslint-disable-next-line max-len
    const bullCodeOptionUrl =
      "https://s3-ap-southeast-2.amazonaws.com/inbreeding-calc-bullcodes/bullCodesAndNames.json";
    const bullOptions = await fetch(bullCodeOptionUrl, {
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, same-origin, *omit
      headers: {
        "user-agent": "Mozilla/4.0 MDN Example",
        "content-type": "application/json",
      },
      method: "GET",
      mode: "cors",
      redirect: "follow",
      referrer: "no-referrer",
    }).then((response) => response.json());
    dispatch({
      type: ActionType.ReceiveBullOptions,
      payload: bullOptions,
    });
  };
  // receive API request from S3
}

/*
 * TODO: IFetchBullOptionsAction IReceiveBullOptionsErrorAction are not implemented at the moment -
 * one day, these should trigger a loading indicator on fetch and handle errors appropriately
 */
export type Action =
  | IFetchBullOptionsAction
  | IReceiveBullOptionsAction
  | IReceiveBullOptionsErrorAction;



// WEBPACK FOOTER //
// ./src/scripts/actions/BullCodeActions.ts